<template>
  <div class="text-center">
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          variant="text"
        >
          <v-icon v-if="!isHeader" icon="mdi-format-list-bulleted"></v-icon>
          <v-icon v-else icon="mdi-dots-horizontal"></v-icon>
        </v-btn>
      </template>
      <v-list
        density="compact"
        nav
      >
        <div v-for="item in menuItems" :key="item.value">
          <v-list-item class="list-item" :prepend-icon="item.icon" :title="isMobile ? '' : item.title" :value="item.value" @click="itemClicked(item)"/>
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
    isHeader: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    itemClicked(item) {
      const obj = JSON.parse(JSON.stringify(item));
      this.emitter.emit('clicked', obj);
      this.show = false;
    },
  }
};
</script>

<style lang="scss" scoped>
</style>